import { render, staticRenderFns } from "./sidebar-banners.vue?vue&type=template&id=f6f392ce&"
import script from "./sidebar-banners.vue?vue&type=script&lang=js&"
export * from "./sidebar-banners.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-banners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sidebar-banners.vue"
export default component.exports